import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { Switch as MuiSwitch } from '@material-ui/core';
import { COLORS } from "../../constants/colors";
export var _Switch = styled(MuiSwitch)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    height: 40px;\n    width: 64px;\n    padding: 0px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    && .MuiSwitch-switchBase:hover + span.MuiSwitch-track {\n      box-shadow: 0 0 0 8px ", ";\n    }\n    && .MuiSwitch-switchBase:hover.Mui-checked:not(.Mui-focusVisible) + span.MuiSwitch-track {\n      box-shadow: 0 0 0 8px ", ";\n    }\n    // there was a default hover for the thumb circle\n    && .MuiIconButton-root:hover {\n      background-color: transparent;\n    }\n\n    && .MuiSwitch-switchBase.Mui-focusVisible + span.MuiSwitch-track {\n      box-shadow:\n        0 0 0 1px ", ",\n        0 0 0 3px ", ";\n    }\n\n    && .MuiSwitch-switchBase {\n      padding: 12px 0px;\n      left: 12px;\n\n      &.Mui-checked {\n        transform: translateX(24px);\n      }\n    }\n\n    && .MuiSwitch-thumb {\n      height: 16px;\n      width: 16px;\n      border-radius: 50%;\n      background-color: ", ";\n    }\n\n    && .MuiSwitch-track {\n      height: 24px;\n      width: 48px;\n      box-sizing: border-box;\n      opacity: 1;\n      border-radius: 12px;\n      border-style: solid;\n      border-color: ", ";\n      border-width: 2px;\n      background-color: ", ";\n    }\n  }\n"])), COLORS["switch"].hover.unselected, COLORS["switch"].hover.selected, COLORS["switch"].white, COLORS["switch"].main.selected, getCircleColor, getBorderColor, getMainColor);
function getBorderColor(props) {
  if (props.disabled) {
    return COLORS["switch"].disabled.color;
  }
  if (props.checked) {
    return COLORS["switch"].main.selected;
  }
  return COLORS["switch"].main.unselected;
}
function getMainColor(props) {
  if (props.checked && !props.disabled) {
    return COLORS["switch"].main.selected;
  }
  if (props.checked && props.disabled) {
    return COLORS["switch"].disabled.color;
  }
  return COLORS["switch"].white;
}
function getCircleColor(props) {
  if (props.checked) {
    return COLORS["switch"].white;
  }
  if (props.disabled) {
    return COLORS["switch"].disabled.color;
  }
  return COLORS["switch"].main.unselected;
}